import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ORIGINS = {
	tr: '100% 0%',
	bl: '0% 100%',
};

const bindSection = (section) => {
	const motions = section.querySelectorAll('.js-video-decoration');
	const paths = section.querySelectorAll('.video-section__decoration .pricing__decoration-path');
	const anchors = section.querySelectorAll('.video-section__decoration');

	if (!motions.length || !paths.length || !anchors.length) {
		return null;
	}

	motions.forEach((motion) => {
		const side = motion.dataset.videoDecoration === 'bl' ? 'bl' : 'tr';
		gsap.set(motion, { transformOrigin: ORIGINS[side] });
	});
	paths.forEach((path) => {
		gsap.set(path, { transformOrigin: '50% 50%', opacity: 0.1 });
	});

	let idleTweens = [];
	let glowTweens = [];

	const entrance = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: 'top 80%',
			once: true,
		},
		defaults: { ease: 'power3.out' },
		onComplete: () => {
			motions.forEach((motion) => {
				const idleTween = gsap.to(motion, {
					y: motion.dataset.videoDecoration === 'bl' ? -7 : 7,
					duration: 2.6,
					ease: 'sine.inOut',
					yoyo: true,
					repeat: -1,
				});
				idleTweens.push(idleTween);
			});

			paths.forEach((path) => {
				const glowTween = gsap.to(path, {
					opacity: 0.17,
					duration: 2.6,
					ease: 'sine.inOut',
					yoyo: true,
					repeat: -1,
				});
				glowTweens.push(glowTween);
			});
		},
	});

	motions.forEach((motion, index) => {
		const side = motion.dataset.videoDecoration === 'bl' ? 'bl' : 'tr';
		const from = side === 'bl' ? { y: 28, rotation: 10 } : { y: -28, rotation: -10 };

		entrance.fromTo(
			motion,
			{ ...from, autoAlpha: 0 },
			{ y: 0, rotation: 0, autoAlpha: 1, duration: 1.15 },
			index * 0.08,
		);
	});

	entrance.fromTo(
		paths,
		{ scale: 0.55, opacity: 0 },
		{ scale: 1, opacity: 0.1, duration: 0.9, ease: 'back.out(1.6)', stagger: 0.08 },
		'-=0.78',
	);

	const parallax = gsap.fromTo(
		anchors,
		{ y: 8 },
		{
			y: -16,
			ease: 'none',
			scrollTrigger: {
				trigger: section,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 0.85,
			},
		},
	);

	return () => {
		entrance.scrollTrigger?.kill();
		parallax.scrollTrigger?.kill();
		idleTweens.forEach((tween) => tween.kill());
		glowTweens.forEach((tween) => tween.kill());
		gsap.killTweensOf([...motions, ...paths, ...anchors]);
		gsap.set([...motions, ...paths, ...anchors], { clearProps: 'all' });
		paths.forEach((path) => {
			path.style.opacity = '0.1';
		});
	};
};

export const initVideoDecoration = () => {
	const sections = document.querySelectorAll('.section--video-section');
	if (!sections.length) {
		return;
	}

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference) and (min-width: 1100px)', () => {
		sections.forEach((section) => {
			const cleanup = bindSection(section);
			if (cleanup) {
				cleanups.push(cleanup);
			}
		});

		return () => {
			cleanups.forEach((fn) => fn());
		};
	});
};
